module.exports = __webpack_public_path__ + "media/assets/ding-6078dee85551449a6e70534235bf1aa9.mp3";